<template>
  <section class="account-form">
    <div class="header">
      <h2>Edit Profile</h2>
      <div class="btn">
        <v-button @click="handleCancel">Cancel</v-button>
        <v-button
          class="success"
          @click="submitForm">Save</v-button>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="formRule">
      <div class="pic-name">
        <div class="pic">
          <span class="title">Profile Picture</span>
          <v-upload
            card
            notUpload
            hideBtn
            :fileData="{
              url: formData.avatar_thumb_url,
              thumb_url: formData.avatar_thumb_url,
              client_name: 'avatar'
            }"
            @delete="handlerDeleteFile"
            @uploadForm="handlerGetUploadImg"></v-upload>
        </div>
        <div
          v-if="formData.identity == 1"
          class="info">
          <div class="top">
            <div class="select-title">
              <span class="title">Title</span>
              <el-form-item
                ref="isrd_title"
                prop="isrd_title">
                <v-select
                  v-model="formData.isrd_title"
                  width="100px"
                  :list="titleOptions" />
              </el-form-item>
            </div>
            <div class="first-name ">
              <span class="title">Last Name</span>
              <el-form-item
                ref="isrd_lst_nm"
                prop="isrd_lst_nm">
                <v-input
                  v-model="formData.isrd_lst_nm"
                  uppercase />
              </el-form-item>
            </div>
            <div class="last-name">
              <span class="title">First Name</span>
              <el-form-item
                ref="isrd_fst_nm"
                prop="isrd_fst_nm">
                <v-input
                  v-model="formData.isrd_fst_nm"
                  uppercase />
              </el-form-item>
            </div>
          </div>
          <div class="bottom">
            <div class="nick">
              <span class="title">Nickname</span>
              <el-form-item
                ref="nick_name"
                prop="nick_name">
                <v-input
                  v-model="formData.nick_name"
                  uppercase />
              </el-form-item>
            </div>
          </div>
        </div>
      </div>

      <div class="line"></div>

      <template v-if="formData.identity == 1">
        <div class="contact">
          <div class="mobile item">
            <span class="title">Mobile Number</span>
            <div class="info">
              <span class="num">{{formData.phone}}</span>
              <v-button @click="mobileEdit">Edit</v-button>
            </div>
          </div>

          <div
            v-if="!formData.draft_email"
            class="email item">
            <span class="title">Email</span>
            <div class="info">
              <span class="num">
                {{formData.email}}
                <font-awesome-icon
                  v-if="formData.email"
                  icon="check-circle"
                  class="check icon"></font-awesome-icon>
              </span>
              <v-button @click="emailEdit">Edit</v-button>
            </div>
          </div>
          <div
            v-else
            class="email item">
            <span class="title">Email</span>
            <div
              v-if="formData.email"
              class="info">
              <span class="num">
                {{formData.email}}
                <font-awesome-icon
                  icon="check-circle"
                  class="check icon"></font-awesome-icon>
              </span>
            </div>
            <div class="info">
              <span class="num">
                {{formData.draft_email}}
                <span class="status">
                  <font-awesome-icon
                    icon="warning"
                    class="icon"></font-awesome-icon>
                  Unverified
                </span>
              </span>
            </div>
            <div class="btnList">
              <v-button
                class="send"
                :class="{'gray': sendBtnDisabled}"
                :disabled="sendBtnDisabled"
                @click="sendVerification">
                <span class="label-name">Send verification</span>
                <span
                  v-if="sendBtnDisabled"
                  class="second">{{seconds}}s</span>
              </v-button>
              <v-button
                v-if="formData.email"
                @click="draftEmailCancel">Cancel</v-button>
              <v-button @click="emailEdit">Edit</v-button>
            </div>
          </div>

          <div class="pwd item">
            <span class="title">Password</span>
            <div class="info">
              <v-button @click="handlerPassword('sms')">Send Reset Link SMS</v-button>
            </div>
          </div>

          <div class="birth item">
            <span class="title">Date of Birth</span>
            <el-form-item
              ref="isrd_dob"
              prop="isrd_dob">
              <v-birth-day v-model="formData.isrd_dob" />
            </el-form-item>
          </div>

          <div class="hkid item">
            <span class="title">HKID</span>
            <v-input
              v-model="formData.id_no"
              uppercase
              placeholder="A123456(3), please input A1234563" />
          </div>

          <div class="passport item">
            <span class="title">Passport No.</span>
            <v-input
              v-model="formData.pp_no"
              uppercase />
          </div>

          <div class="passport item">
            <span class="title">Nationality</span>
            <v-select
              v-model="formData.id_nationality_seq"
              :list="nationalityList" />
          </div>

          <div class="file item">
            <span class="title">HKID/Passport</span>
            <v-upload
              card
              widthFull
              :fileData="{
                url: formData.id_type_pic_url,
                thumb_url: formData.id_type_pic_url,
                client_name: 'id_type'
              }"
              :otherData="{
                idKey: 'id_type_pic_path_id',
                nameKey: 'id_type_pic_path',
                urlKey: 'id_type_pic_url',
                client_name: 'id_type'
              }"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess"></v-upload>
          </div>

        </div>
      </template>

      <template v-else>
        <div class="contact">

          <div class="email item company-email">
            <span class="title">Email</span>
            <div
              v-if="!formData.attached_account"
              class="info">
              <span class="num">{{formData.email}}</span>
              <v-button @click="handleChangeEmail(1)">Edit</v-button>
            </div>
            <div
              v-else
              class="info">
              <span class="link num">
                <font-awesome-icon
                  icon="link"
                  class="icon"></font-awesome-icon>
                <span>{{formData.email}}</span>
              </span>
              <v-button @click="handleChangeEmail(2)">Edit</v-button>
            </div>
          </div>

          <div class="company-name item">
            <span class="title">Company Name</span>
            <v-input
              v-model="formData.isrd_com_nm"
              uppercase />
          </div>

          <div class="ci item">
            <span class="title">Business Registration Number</span>
            <el-form-item
              ref="id_no"
              prop="id_no">
              <v-input
                v-model="formData.id_no"
                uppercase
                letterAndNumber
                maxlength="8"
              />
            </el-form-item>
          </div>

          <div class="phone item">
            <span class="title">Company Phone Number</span>
            <el-form-item
              ref="phone_no"
              prop="phone_no">
              <v-input
                v-model="formData.phone_no"
                maxlength="8"
                type="number"/>
            </el-form-item>
          </div>

          <div class="nature item">
            <span class="title">Nature of Business</span>
            <el-form-item
              ref="bsns_nature_id"
              prop="bsns_nature_id">
              <v-select
                v-model="formData.bsns_nature_id"
                :list="allOptions.industry" />
            </el-form-item>
          </div>

          <div class="file item">
            <span class="title">Business Registration Certification</span>
            <v-upload
              card
              widthFull
              :fileData="{
                url: formData.id_type_pic_url,
                thumb_url: formData.id_type_pic_url,
                client_name: 'id_type'
              }"
              :otherData="{
                idKey: 'id_type_pic_path_id',
                nameKey: 'id_type_pic_path',
                urlKey: 'id_type_pic_url',
                client_name: 'id_type'
              }"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess"></v-upload>
          </div>

        </div>
      </template>

      <div class="line"></div>

      <template v-if="formData.identity !== 1">
        <div class="contact-person">
          <p class="item">Contact Person</p>
          <div class="item">
            <span class="title">Name</span>
            <el-form-item
              ref="contact_nm"
              prop="contact_nm">
              <v-input
                v-model="formData.contact_nm"
                uppercase />
            </el-form-item>
          </div>

          <div class="item">
            <span class="title">Phone Number</span>
            <el-form-item
              ref="contact_phone"
              prop="contact_phone">
              <v-input
                v-model="formData.contact_phone"
                maxlength="8"
                type="number"/>
            </el-form-item>
          </div>

        <!-- <div class="item">
          <span class="title">Email</span>
          <el-form-item
            ref="contact_phone"
            prop="contact_phone">
            <v-input
              v-model="formData"
              type="number"/>
          </el-form-item>
        </div> -->


        </div>
        <div class="line"></div>
      </template>

      <div class="refer">
        <div
          v-if="formData.identity == 1"
          class="code item">
          <span class="title">Referral Code / Member’s Mobile No.</span>
          <div class="info">
            {{formData.referrer_code}}
          </div>
        </div>

        <div class="communicate item">
          <span class="title">Language</span>
          <el-form-item
            ref="language"
            prop="language">
            <v-select
              v-model="formData.language"
              :list="langList"/>
          </el-form-item>
        </div>
      </div>

      <div class="line"></div>

      <div class="communicate item">
        <span class="title">Communication Preference</span>
        <el-form-item
          ref="is_comm_sub"
          prop="is_comm_sub">
          <v-checkbox
            v-model="formData.is_comm_sub">Marketing Communications</v-checkbox>
        </el-form-item>
      </div>

      <div class="line"></div>

      <div class="addr">
        <p class="item">Address</p>
        <div class="address item">
          <div class="room">
            <span class="en">Room</span>
            <span class="zh">室</span>
            <el-form-item
              ref="addr_room"
              prop="addr_room">
              <v-input
                v-model="formData.addr_room"
                maxlength="5"
                uppercase />
            </el-form-item>
          </div>
          <div class="floor">
            <span class="en">Floor</span>
            <span class="zh">樓</span>
            <el-form-item
              ref="addr_floor"
              prop="addr_floor">
              <v-input
                v-model="formData.addr_floor"
                maxlength="5"
                uppercase />
            </el-form-item>
          </div>
          <div class="block">
            <span class="en">Block</span>
            <span class="zh">座</span>
            <el-form-item
              ref="addr_block"
              prop="addr_block">
              <v-input
                v-model="formData.addr_block"
                maxlength="5"
                uppercase />
            </el-form-item>
          </div>
        </div>
        <div class="build item">
          <span class="en">Building/Estate</span>
          <span class="zh">大廈/屋苑名稱</span>
          <el-form-item
            ref="addr_building"
            prop="addr_building">
            <v-input
              v-model="formData.addr_building"
              uppercase />
          </el-form-item>
        </div>
        <div class="street item">
          <span class="en">Street</span>
          <span class="zh">街名</span>
          <el-form-item
            ref="addr_street"
            prop="addr_street">
            <v-input
              v-model="formData.addr_street"
              uppercase />
          </el-form-item>
        </div>
        <div class="dist item">
          <div class="district">
            <span class="en">District</span>
            <span class="zh">區域</span>
            <el-form-item>
              <v-select
                v-model="formData.addr_district"
                :list="allOptions.area.district"
                @change="changeDistrict" />
            </el-form-item>
          </div>
          <div class="area">
            <span class="en">Area</span>
            <span class="zh">地域</span>
            <el-form-item>
              <v-select
                v-model="formData.addr_area"
                :list="allOptions.area.area"
                @change="changeArea" />
            </el-form-item>
          </div>
          <div class="country">
            <span class="en">Country / Region</span>
            <span class="zh">國家/地區</span>
            <el-form-item>
              <v-select
                v-model="formData.addr_region"
                :list="allOptions.area.region"
                @change="changeRegion" />
            </el-form-item>
          </div>
        </div>
      </div>

      <div class="line"></div>

      <div class="bank">
        <p class="item">Bank Account</p>
        <div class="item">
          <span class="title">Bank</span>
          <el-form-item>
            <v-select
              v-model="formData.bank_code"
              valueKey="bank_code"
              :labelKey="'bank_name'"
              :list="bankList" />
          </el-form-item>
        </div>

        <div class="item">
          <span class="title">Bank Account Holder's Name</span>
          <el-form-item
            prop="bank_holder">
            <v-input
              v-model="formData.bank_holder"
              uppercase />
          </el-form-item>
        </div>

        <div class="item">
          <span class="title">Bank Number</span>
          <el-form-item
            prop="bank_number">
            <v-input
              v-model="formData.bank_number"
              maxlength="20"
              type="number" />
          </el-form-item>
        </div>
      </div>

      <div class="line"></div>

      <template v-if="formData.identity !== 1">
        <div class="pwd">
          <p class="item">Password</p>
          <div class="item">
            <div class="button">
              <v-button @click="handlerPassword('email')">Send Reset Password Email</v-button>
            </div>
          </div>
        </div>
        <div class="line"></div>
      </template>

      <div class="btn">
        <v-button
          class="success"
          @click="submitForm">Save</v-button>
      </div>

    </el-form>

    <profile-edit
      ref="profile-edit"
      :setStep="setStep"
      :type="type"
      @verifyEmail="verifyEditEmail"></profile-edit>
    <send-verification
      ref="send-verfication"
      :email="formData.draft_email"
      @sendVerify="sendVerify"></send-verification>

    <send-email-sms
      ref="send-email-sms"
      :form="formData"
      :skip="false"
      :is-edit="true"
      :initContent="detail.reset_url_data"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      @send="handlerSend" />

    <crop-pic
      ref="crop"
      :direct="0"
      :otherData="{
        idKey: 'avatar_pic_path_id',
        nameKey: 'avatar_pic_path',
        urlKey: 'avatar_thumb_url',
        client_name:'avatar'
      }"
      :imgSrc="imgSrc"
      :uploadData="{
        type: 'avatar_pic_path'
      }"
      @uploadSuccess="handlerUploadSuccess"></crop-pic>

  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {checkEmail,checkMobile} from '@/utils/validate'
import profileEdit from '../popup/profile-edit.vue'
import sendVerification from '../popup/send-verification.vue'
import {editAccount, draftEmailCancel, sendPasswordRestList} from '@api/account'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import cropPic from '../popup/crop-pic.vue'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'AccountForm',
  components:{
    profileEdit,
    sendVerification,
    SendEmailSms,
    cropPic
  },
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    edit: {
      type: Boolean,
      default: false
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    notValid: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: [Number, String],
      default: 0
    },
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const checkIdNo = (rule, value, callback) => {
      const { identity, pp_no } = this.formData
      var reg = /[^\w\/]/
      if (identity == 2 && value && reg.test(value)) {
        callback( new Error( '公司註冊證書編號最多为8位字母和數字' ) )
      }
      else {
        if(!pp_no && !value) {
          callback(new Error(this.$t('placeholder.input')))
        }
      }
      callback()
    }
    const checkAddrRequired = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      if(this.notValid) {
        callback()
      }
      if(this.allRequired && !valueResult) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    const checkRequired = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      if(this.notValid) {
        callback()
      }
      const require = this.isRequired && this.requireValid

      if(require && !valueResult) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    return {
      formData: {
        identity: 1,
        phone: '',
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        email: '',
        isrd_sex: '',
        isrd_dob: '',
        id_type: '',
        isrd_title: '',
        id_no: '',
        pp_no: '',
        isrd_com_nm: '',
        contact_nm: '',
        contact_phone: '',
        bsns_nature_id: '',
        id_type_pic_path:'',
        id_type_pic_url:'',
        client_name:'',
        nick_name: '',
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
        referrer_code:'',
        language:'zh-HK',
        id: '',
        avatar_thumb_url: '',
        avatar_pic_path_id: '',
        draft_email: '',
        attached_account: false,
        phone_no: '',
        bank_code: '',
        bank_holder: '',
        bank_number: '',
        id_nationality_seq: '',
        is_comm_sub: 0
      },
      extraRules: {
        id_no: [
          { validator: checkIdNo, trigger: ['change', 'blur'] }
        ],
        // addr_room: [
        //   { validator: checkAddrRequired, trigger: ['change', 'blur'] }
        // ],
        // addr_floor: [
        //   { validator: checkAddrRequired, trigger: ['change', 'blur'] }
        // ],
        // addr_block: [
        //   { validator: checkAddrRequired, trigger: ['change', 'blur'] }
        // ],
        // addr_building: [
        //   { validator: checkAddrRequired, trigger: ['change', 'blur'] }
        // ],
        // addr_street: [
        //   { validator: checkAddrRequired, trigger: ['change', 'blur'] }
        // ],
        // addr_district: [
        //   { validator: checkRequired, trigger: ['change', 'blur'] }
        // ],
        // addr_area: [
        //   { validator: checkRequired, trigger: ['change', 'blur'] }
        // ],
        // addr_region: [
        //   { validator: checkRequired, trigger: ['change', 'blur'] }
        // ],
      },
      type: 1,
      setStep: 1,
      seconds: 60,
      sendBtnDisabled: false,
      timer: null,
      imgSrc: ''
    }
  },
  computed:{
    ...mapState('common', ['bankList']),
    formRule(){
      var rule = JSON.stringify(this.rules)
      const select = [
        'isrd_com_nm',
        'email',
        'bsns_nature_id',
        'id_no',
      ]
      const data =[
        'isrd_lst_nm',
        'isrd_fst_nm',
        'isrd_sex',
        'isrd_dob',
        'id_type',
        'isrd_title',
        'occ_id',
        'contact_lst',
        'contact_fst',
        'contact_phone',
        'email'

      ]
      rule = JSON.parse(rule)

      data.forEach(item=>{
        rule[item][0].required =false
        if(item === 'contact_phone') {
          rule[item][0].required =true
          rule[item][1].validator = checkMobile
        }
        if(item ==='email') {
          rule[item][0].required =true
          rule[item][1].validator = checkEmail
        }
      })
      const checkRequired = (rule, value, callback) => {
        const valueResult = value !== null && value !== ''
        const { field } = rule
        if(select.includes(field) && !valueResult) {
          callback(new Error(this.$t('placeholder.input')))
        }
        callback()
      }
      const checkIdNo = (rule, value, callback) => {
        const { identity, pp_no } = this.formData
        var reg = /[^\w\/]/
        if ( value && reg.test(value)) {
          callback( new Error( '公司註冊證書編號最多为8位字母和數字' ) )
        }
        else {
          if(!pp_no && !value) {
            callback(new Error(this.$t('placeholder.input')))
          }
        }
        callback()
      }
      select.forEach(item=>{
        if(this.formData.identity == 2)
        {
          rule[item][0].validator = checkRequired
          if(item=='id_no')
            rule[item][0].validator = checkIdNo
        }
      })
      return rule
    },
    emailTitle(){
      return this.detail.reset_url_title || ''
    },
    emailListTitle(){
      return this.detail.reset_url_list_title || ''
    },
    nationalityList(){
      return this.globalOptions.id_nationality_seq || []
    },
    user_type(){
      let {user_type} = this.$route.query||{}
      return user_type||''
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        Object.keys(this.formData).some(key => {

          if(key in val) {
            this.formData[key] = val[key]
          }
        })
        let {id_type_pic} =val

        if(id_type_pic)
        {
          let {client_name,id,path,thumb_url} =id_type_pic
          this.$set(this.formData, 'id_type_pic_path_id', id)
          this.$set(this.formData, 'id_type_pic_path', path)
          this.$set(this.formData, 'id_type_pic_url', thumb_url)
          this.$set(this.formData, 'client_name', client_name)
        }else{
          this.$set(this.formData, 'id_type_pic_path_id', '')
          this.$set(this.formData, 'id_type_pic_path', '')
          this.$set(this.formData, 'id_type_pic_url', '')
          this.$set(this.formData, 'client_name', '')
        }
      }
    },
    'formData.identity': {
      handler(val) {
        // if(val === 2) {
        //   this.formData.id_type = 3
        // } else {
        //   this.formData.id_type = ''
        // }
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
      }
    },
    'formData.contact_nm':{
      immediate:true,
      handler(val) {
        if(val)
          this.formData.contact_nm = this.formData.contact_nm.toLocaleUpperCase()
      }
    }
  },
  created() {
    this.getBankList()
  },
  methods: {
    ...mapActions('common', ['getBankList']),
    handleChangeEmail(type=1){
      let {isrd_com_nm,email} = this.formData||{}
      this.$emit('changeEmail',{isrd_com_nm,email,type})
    },
    handlerChange(){
      this.$emit('handlerChange',this.formData.identity)
    },
    handlerDeleteFile({otherData}) {
      const { idKey, nameKey, urlKey } = otherData
      this.$set(this.formData, idKey, '')
      this.$set(this.formData, urlKey, '')
      this.$set(this.formData, nameKey, '')
      this.$set(this.formData, 'client_name', '')
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey,  urlKey } = otherData
      const { id, name, thumb_url,client_name } = data

      this.$set(this.formData, idKey, id)
      this.$set(this.formData, urlKey, thumb_url)
      this.$set(this.formData, nameKey, name)
      this.$set(this.formData, 'client_name', client_name)
      this.$refs['form'].clearValidate([idKey])
    },
    handlerGetUploadImg({  result }){
      this.imgSrc = result.url
      this.$refs['crop'].changeDialog()
    },
    changeDistrict(id) {
      let { addr_area, addr_region } = this.formData
      const pid = this.getAreaData('district', id).pid
      // 檢查 area
      if(addr_area !== pid) {
        this.formData.addr_area = pid
      }
      // 檢查 region
      const areaPid = this.getAreaData('area', pid).pid
      if(addr_region !== areaPid) {
        this.formData.addr_region = areaPid
      }
    },
    changeArea(id) {
      let { addr_region, addr_district } = this.formData
      const pid = this.getAreaData('area', id).pid
      if(addr_region !== pid) {
        this.formData.addr_region = pid
      }
      const districtPid = this.getAreaData('district', addr_district).pid
      if(districtPid !== id) {
        this.formData.addr_district = ''
      }
    },
    changeRegion(id) {
      const areaPid = this.getAreaData('area', this.formData.addr_area).pid
      if(areaPid !== id) {
        this.formData.addr_area = ''
        this.formData.addr_district = ''
      }
    },
    submitForm() {
      this.$refs.form.validate((valid, rules) => {
        if(valid) {
          let params = JSON.parse(JSON.stringify(this.formData))
          if(params.draft_email){
            params.email = params.draft_email
          }
          params.user_type = this.user_type
          this.network().editAccount(params)
        }
        else {
          this.scrollToValidDom(rules)
        }
      })
    },

    verifyEditEmail(email){
      this.formData.email = email
      let params = JSON.parse(JSON.stringify(this.formData))
      params.user_type = this.user_type
      this.network().editAccount(params, 'editEmail')
    },

    mobileEdit(){
      this.type = 1
      this.$refs['profile-edit'].changeDialog()
    },
    emailEdit(){
      this.type = 2
      this.$refs['profile-edit'].changeDialog()
    },
    draftEmailCancel(){
      this.network().draftEmailCancel()
    },
    sendVerification(){
      this.$refs['send-verfication'].changeDialog()
    },
    handleCancel(){
      this.$emit('cancel')
    },
    updateAccount(){
      this.$parent.handleUpdate()
    },

    sendVerify(){
      this.seconds = 60
      this.sendBtnDisabled = true
      if(this.timer){
        clearInterval(this.timer)
      }
      this.timer = null
      this.timer = setInterval(() => {
        this.seconds --
        if(this.seconds === 0){
          clearInterval(this.timer)
          this.timer = null
          this.sendBtnDisabled = false
        }
      },1000)
    },

    handlerPassword(type){
      if(this.formData.attached_account && type === 'email')
        this.$NewMessageDialog({
          dialogData: { title:'Linked Account'},
          message: 'This account’s login credentials is linked. This will reset the password for all linked accounts. Continue?',
        }).then(()=>{
          this.$refs['send-email-sms'].changeDialog()
        })
      else{
        this.$refs['send-email-sms'].changeDialog()
      }
    },

    handlerSend(content) {
      this.network().sendPasswordRestList(content)
    },

    network(){
      return {
        editAccount: async (params, target) => {
          const { data } = await editAccount(params)
          if(!target){
            // 编辑邮箱的时候不提示
            this.$message({
              type: 'success',
              message: 'Success',
            })
          }
          this.updateAccount()
          this.setStep = 3
          this.handleCancel()
        },

        draftEmailCancel: async () => {
          const {data} = await draftEmailCancel({
            user_id: this.customerId
          })
          if(data.code === 1000){
            this.$message({
              type: 'success',
              message: 'Success',
            })
            this.updateAccount()
          }
        },

        sendPasswordRestList: async (content) => {
          const { status } = await sendPasswordRestList({
            customer_id:this.customerId,
            content,
            type: 2
          })

          if (status == 200){
            // this.$refs['send-email-sms'].changeDialog()
            this.$NewMessageDialog({
              dialogData: {title:'Link Sent'},
              message: 'The reset password link has been sent.',
              isUnitButton:true,
              unitText:'OK',
              isPlain:true
            })
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.account-form {
  width: 690px;
  margin: auto;
  .header{
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    h2{
      padding: 0;
      font-weight: 600;
      font-size: 20px;
      color: #24292E;
    }
  }
  .item{
    margin-bottom: 20px;
  }
  .el-button{
    background: #FAFBFC;
    border: 1px solid rgba(27, 31, 35, 0.15);
    box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
    border-radius: 6px;
    font-weight: 600;
    font-size: 14px;
    font-family: 'Inter';
  }
  .title{
    height: 20px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.15px;
    color: #24292E;
    display: inline-block;
    margin-bottom: 8px;
    padding: 0;
  }
  .pic-name{
    display: flex;
    .pic{
      margin-right: 30px;
      .v-upload-container{
        width: 150px;
        /deep/.upload-card{
          width: 150px;
          height: 150px;
          border-radius: 150px;
          border: 1px solid #91939a;
          img{
            border-radius: 150px;
            width: 150px;
            height: 150px;
            object-fit: cover;
          }
        }
        /deep/.upload-container{
          border-radius: 150px;
          width: 150px;
          height: 150px;
        }
      }
    }
    .info{
      .top{
        display: flex;
        margin-bottom: 20px;
        .select-title{
          width: 100px;
        }
        .first-name{
          margin: 0 20px;
        }
      }
    }
  }
  .line{
    border: 1px solid #D1D5DA;
    margin: 30px 0;
  }
  .contact{
    width: 330px;
    .mobile{
      .info{
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .num{
          color: #24292E;
        }
      }
    }
    .email{
      .info{
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .num{
          color: #24292E;
          .icon{
            font-weight: 900;
            font-size: 14px;
            margin-left: 9px;
          }
          .check{
            color: #22863A;
          }
          .status{
            color: #B08800;
            font-size: 12px;
            font-weight: 600;
          }
        }
      }
      .btnList{
        margin-top: 20px;
        .send{
          color: #0366D6;
        }
        .second{
          font-size: 12px;
        }
        .gray{
          width: 170px;
          color: #999;
          .label-name{
            padding-right: 3px;
            opacity: 0.5;
          }
        }
      }
    }
    .file{
      /deep/.upload-card{
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .company-email{
      .link{
        color: #6F42C1 !important;
        .icon{
          margin: 0 7px 0 0 !important;
        }
      }
    }
  }
  .contact-person, .pwd{
    width: 330px;
    p{
      font-weight: 600;
      font-size: 16px;
      color: #24292E;
    }
  }
  .refer{
    width: 330px;
    .code{
      .info{
        height: 20px;
      }
    }
  }
  .addr{
    p{
      font-weight: 600;
      font-size: 16px;
      color: #24292E;
    }
    .address, .dist{
      display: flex;
      .room, .floor, .block, .district, .area, .country{
        display: flex;
        flex-direction: column;
        color: #24292E;
        font-size: 14px;
        width: 150px;
        .en{
          font-weight: 600;
        }
        .zh{
          font-weight: 400;
          padding: 2px 0 8px 0;
        }
      }
      .floor, .area{
        margin: 0 15px;
      }
    }
    .build, .street{
      width: 330px;
      display: flex;
      flex-direction: column;
      color: #24292E;
      font-size: 14px;
      .en{
        font-weight: 600;
      }
      .zh{
        font-weight: 400;
        padding: 2px 0 8px 0;
      }
    }
  }
  .bank{
    width: 330px;
    p{
      font-weight: 600;
      font-size: 16px;
      color: #24292E;
    }
  }
  .btn{
    text-align: right;
    .el-button{
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-sizing: border-box;
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      border-radius: 6px;
      font-weight: 600;
      font-family: 'Inter';
    }
    .success{
      background: #2EA44F;
      color: #FFFFFF;
    }
  }
  .pwd{
    .el-button{
      color: #24292E;
    }
  }
}
</style>
